import React from "react";
import Country from "src/source-forms/inputs/country.component.js";

export default class OtherCountries extends React.Component {
  render() {
    return <Country variousCountries={true} {...this.props} />;
  }
}
